import { render } from "./PlayableCardDetail.vue?vue&type=template&id=2a237a68"
import script from "./PlayableCardDetail.vue?vue&type=script&lang=js"
export * from "./PlayableCardDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__